module.exports = __webpack_public_path__ + "static/media/fuerte.eaa65794.svg";